var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt'),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("\n     Copyright © 2020- JALG inc. All Right Reserved. \n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }